import { useEffect, useMemo, useRef, useState } from 'react'
import { ProjectModal } from '../ProjectModal/ProjectModal'
import { FilterTableRow } from './components/FilterTableRow'

import { useTranslation } from 'react-i18next'
import { IProyectos } from '../../data/data.model'

interface IFilterTable {
  data: IProyectos[]
}

interface IProjectState {
  id_estado: string
  estado: string
}

export const FilterTable = ({ data }: IFilterTable) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [posTop, setPosTop] = useState<number>(0)
  const { t }: any = useTranslation()
  const [statesData, setStatesData] = useState<Map<string, IProyectos[]>>(
    new Map<string, IProyectos[]>()
  )

  const projectStates: IProjectState[] = useMemo(
    () => [
      {
        id_estado: 'production',
        estado: t('filters.states.production'),
      },
      {
        id_estado: 'construction',
        estado: t('filters.states.construction'),
      },
      {
        id_estado: 'prefeasibility',
        estado: t('filters.states.prefeasibility'),
      },
      {
        id_estado: 'exploration',
        estado: t('filters.states.exploration'),
      },
      {
        id_estado: 'prospecting',
        estado: t('filters.states.prospecting'),
      },
      {
        id_estado: 'unknown',
        estado: t('filters.states.unknown'),
      },
      {
        id_estado: 'inactive',
        estado: t('filters.states.inactive'),
      },
    ],
    [t]
  )

  useEffect(() => {
    if (data.length === 0) return

    const statesMap = new Map<string, IProyectos[]>()

    projectStates.forEach((projectState: IProjectState) => {
      statesMap.set(
        projectState.id_estado,
        data.filter(
          (project: IProyectos) => project.phase_or_status === projectState.id_estado
        )
      )
    })

    setStatesData(statesMap)
  }, [data, projectStates])

  /**
  * calcula el top de este componente para pasarle la posicion al modal
  * y que este se muestre en la posicion correcta
  */
  useEffect(() => {
    const updatePosition = () => {
      if (!containerRef.current) return
      const rect = containerRef.current.getBoundingClientRect()
      setPosTop(rect.top + window.scrollY)
    }

    updatePosition()
    window.addEventListener('resize', updatePosition)
    return () => window.removeEventListener('resize', updatePosition)
  }, [])

  const getTableRows = useMemo(() => {
    if (statesData.size > 0) {
      return projectStates.map((projectState, index) => {
        return (
          <FilterTableRow
            key={index}
            estado={projectState.estado}
            id_estado={projectState.id_estado}
            data={statesData.get(projectState.id_estado) || []}
          ></FilterTableRow>
        )
      })
    }
  }, [statesData, projectStates])

  return (
    <div ref={containerRef} style={{ marginTop: '50px', width: '100%' }}>
      <div>{getTableRows}</div>
      <ProjectModal containerRef={containerRef} posTop={posTop}></ProjectModal>
    </div>
  )
}
